import React, { useEffect, useRef, useState } from 'react'
import { Box, styled } from '@chilipiper/design-system'
import { TextArea, IconButton } from '@chilipiper/design-system/src/new'
import { IconArrowTop } from '@chilipiper/icons/figma-generated/src/icon'
import { useMessageFeedContext } from '../chat-widget/MessageFeedContext'

interface Props {
  sendMessage: (text: string) => void
  sendingMessage: boolean
  isDisabled: boolean
}

const StyledForm = styled.form`
  position: relative;
  width: 100%;
`

export const ChatInput = ({ sendMessage, sendingMessage, isDisabled: isDisabledProp }: Props) => {
  const [text, setText] = useState('')
  const ref = useRef<HTMLFormElement>(null)
  const { isNarrowScreen } = useMessageFeedContext()

  const trimmedText = text.replace(/(^\s+)|(\s+$)/g, '')
  const isDisabled = sendingMessage || !trimmedText || isDisabledProp
  const size = isNarrowScreen ? 'large' : 'regular'

  const handleSend = () => {
    if (isDisabled) {
      return
    }

    sendMessage(trimmedText)
    setText('')
  }

  useEffect(() => {
    if (ref.current) {
      ref.current.querySelector('textarea')?.focus()
    }
  }, [])

  return (
    <StyledForm
      ref={ref}
      onSubmit={e => {
        e.preventDefault()
        handleSend()
      }}
    >
      <TextArea
        label={<TextArea.Label position='hidden'>Chat message</TextArea.Label>}
        value={text}
        placeholder='Enter...'
        onChange={setText}
        minHeight={9}
        maxHeight={15}
        isRequired
        submitOnEnter
        size={size}
      />
      <Box position='absolute' bottom={2} right={2}>
        <IconButton
          icon={IconArrowTop}
          label='Send Chat message'
          variant='major'
          size={7}
          isDisabled={isDisabled}
          onClick={handleSend}
        />
      </Box>
    </StyledForm>
  )
}
